import { render } from "./terms.vue?vue&type=template&id=bf9846be&scoped=true"
import script from "./terms.vue?vue&type=script&lang=js"
export * from "./terms.vue?vue&type=script&lang=js"

import "./terms.vue?vue&type=style&index=0&id=bf9846be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf9846be"]])

export default __exports__